import { Controller } from '@hotwired/stimulus';
import { iconSvg } from '../tools/iconSvg';

/*eslint no-undef: "error"*/

const MAP_ID = AppConfig.googleMapsMapId;
const MAP_API_KEY = AppConfig.googleMapsApiKey;

export default class extends Controller {
	static values = {
		center: Object,
		markers: Array,
		threshold: { type: Number, default: 0.5 },
	};

	static targets = ['marker', 'content'];

	connect() {
		this.loadGoogleMaps().then(() => this.initObserver());
	}

	async loadGoogleMaps() {
		if (!window.google) {
			await new Promise((resolve) => {
				const script = document.createElement('script');
				script.src = `https://maps.googleapis.com/maps/api/js?key=${MAP_API_KEY}&libraries=marker`;
				script.defer = true;
				script.async = true;
				script.onload = resolve;
				document.head.appendChild(script);
			});
		}
	}

	initObserver() {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					this.initMap();
					observer.disconnect();
				}
			},
			{ threshold: this.thresholdValue },
		);
		observer.observe(this.element);
	}

	initMap() {
		/* eslint-disable no-undef */
		const { Map } = google.maps;
		const { AdvancedMarkerElement } = google.maps.marker;

		this.map = new Map(this.contentTarget, {
			center: this.centerValue,
			zoom: 15,
			mapId: MAP_ID,
		});
		this.addMarkers(AdvancedMarkerElement);

		setTimeout(() => {
			this.map.panBy(40, 140);
		}, 300);
	}

	addMarkers(AdvancedMarkerElement) {
		const infoWindow = new google.maps.InfoWindow();

		this.markersValue.forEach((data) => {
			const lat = parseFloat(data.lat);
			const lng = parseFloat(data.lng);
			const title = data.title || '';
			const address = data.address || '';
			const iconHtml = iconSvg(data.icon ? data.icon : 'marker-market');

			const marker = new AdvancedMarkerElement({
				position: { lat, lng },
				map: this.map,
				title: data.name,
				content: this.createSvgIcon(iconHtml),
			});

			if (!title || !address) {
				return;
			}
			const infoWindowContent = `
				<div class="b-map__marker-dialog-content">
					${title ? `<div class="b-map__marker-dialog-title">${title}</div>` : ''}
					${address ? `<div class="b-map__marker-dialog-address">${address}</div>` : ''}
				</div>
			`;

			marker.addListener('click', () => {
				infoWindow.setContent(infoWindowContent);
				infoWindow.open(this.map, marker);

				google.maps.event.addListenerOnce(infoWindow, 'domready', () => {
					const infoWindowDiv = document.querySelector('.gm-style-iw');
					if (infoWindowDiv) {
						infoWindowDiv.classList.add('b-map__marker-dialog');
					}
				});
			});
		});
	}

	createSvgIcon(svgString) {
		const wrapper = document.createElement('div');
		wrapper.innerHTML = svgString;
		return wrapper;
	}
}
